// extracted by mini-css-extract-plugin
export var avatar = "_nj-3";
export var avatarContainer = "_nj-2";
export var avatarSpacer = "_nj-5";
export var avatarSpacerContainer = "_nj-4";
export var avatarStackContainer = "_nj-1";
export var bubble = "_nj-0";
export var remainderBubble = "_nj-6";